<template>
    <div
        :class="{
            'radio-item': true,
        }"
        @click="onClick">
        <Icon
            class="radio-item__radio"
            :type="checked ? 'radio_checked_dark' : 'radio'"
            :width="25"
            :height="25" />
        <div
            class="radio-item__title">
            {{ title }}
        </div>
        <Icon
            class="radio-item__icon"
            :type="icon"
            :width="22"
            :height="22" />
    </div>
</template>

<script>
export default {
    name: 'RadioItemSelectOption',
    props: {
        checked: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: '',
        },
    },
    methods: {
        onClick () {
            this.$emit('click');
        },
    },
};
</script>

<style scoped lang="scss">
  .radio-item {
    @include font-migrosbank();
    color: $mb-grey5;
    background: $mb-grey-12;
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 35px;
  }

  .radio-item__radio {
    margin: 0 10px;
  }

  .radio-item__title {
    font-size: 15px;
    line-height: 15px;
    flex-grow: 1;
  }

  .radio-item__icon {
    margin-right: 10px;
  }

</style>
